import elementBase from "../elementBase.js";
import fontWeight from "../../definition/fontWeight.js";

export default class DynamicTimeOut extends elementBase {
    objectType = "DynamicTimeOut";
    styleColor = '#553c9a'; // Violet foncé
    Background = '';
    Foreground = '';
    _Police = '';
    FontWeight = '';
    FontSize = 0;

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Background = args.background != null ? args.background : '';
        this.Foreground = args.foreground != null ? args.foreground : '';
        this._Police = args.police != null ? args.police : 'Arial';
        this.FontWeight = args.fontWeight != null ? args.fontWeight : fontWeight.Normal;
        this.FontSize = args.fontSize != null ? args.fontSize : 16;
    }
    static get Name() {
        return "Délai";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Background", type: "colorInput", dataType: "string" },
            { name: "Foreground", type: "colorInput", dataType: "string" },
            { name: "FontSize", type: "numberInput", dataType: "number" },
            { name: "FontWeight", type: "selectInput", dataType: "string", options: fontWeight },
            { name: "Police", type: "textInput", dataType: "string" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    get Police() {
        return this._Police;
    }
    set Police(value) {
        this._Police = value;
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            position: 'absolute',
        }
        return style;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            background: this.hexColorValue(this.Background),
            foreground: this.hexColorValue(this.Foreground),
            police: '@' + this._Police + '@',
            fontWeight: this.FontWeight,
            fontSize: this.FontSize,
        };
    }
    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            background: this.Background,
            foreground: this.Foreground,
            police: this.Police,
            fontWeight: this.FontWeight,
            fontSize: this.FontSize,
        };
        return object;
    }
}
